var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import Settings from './views/CalendarSettings';
var CalendarRouting = function (props) {
    if (props.showSettings) {
        return React.createElement(Settings, __assign({}, props));
    }
    else {
        return (React.createElement("div", null,
            React.createElement("h2", null, "Uh-oh!"),
            React.createElement("p", null,
                "How did you get to ",
                props.location.pathname,
                "?")));
    }
};
export default CalendarRouting;
